import { render, staticRenderFns } from "./PivotWidget.vue?vue&type=template&id=0096ead3&scoped=true"
import script from "./PivotWidget.vue?vue&type=script&lang=js"
export * from "./PivotWidget.vue?vue&type=script&lang=js"
import style0 from "./PivotWidget.vue?vue&type=style&index=0&id=0096ead3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096ead3",
  null
  
)

export default component.exports